var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from "react";
export default ({ defaults, getDefault, handleDefaults, needToFetch = true, }) => {
    const [isFetching, setIsFetching] = useState(needToFetch);
    const getDefaultItems = () => __awaiter(void 0, void 0, void 0, function* () {
        let result = [];
        setIsFetching(true);
        try {
            yield Promise.all(defaults.map((entityName, index) => {
                return getDefault(entityName)
                    .then((response) => {
                    result[index] = response.data.result;
                })
                    .catch(() => {
                    result[index] = null;
                })
                    .finally(() => Promise.resolve());
            }));
            handleDefaults && handleDefaults(result);
        }
        finally {
            setIsFetching(false);
            return result;
        }
    });
    useEffect(() => {
        if (needToFetch)
            getDefaultItems();
    }, [needToFetch]);
    return { isFetching, getDefaultItems };
};
//# sourceMappingURL=useFetchDefaults.js.map